import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import i18n from "../translation/i18n";
import { LOCALES } from "../common/constants";

/**
 * Custom hook to handle language initialization and synchronization
 * - Checks URL params for lang
 * - Falls back to localStorage
 * - Falls back to default Swedish (sv-se)
 * - Syncs language across URL, localStorage, and i18n
 * - Prevents unnecessary re-renders and double loading
 */
export const useLanguageInitialization = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isInitialized = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get("lang");
    const storedLang = localStorage.getItem("i18nextLng");
    
    // Determine the language to use
    let targetLang;
    if (urlLang) {
      targetLang = urlLang;
    // } else if (storedLang) {
    //   targetLang = storedLang;
    } else {
      targetLang = LOCALES.SV_SE;
    }

    // Get current i18n language
    const currentLang = i18n.language?.toLowerCase();

    // Only update if language actually changed
    if (currentLang !== targetLang) {
      localStorage.setItem("i18nextLng", targetLang);
      i18n.changeLanguage(targetLang);
    }

    // Only navigate if no lang in URL and we haven't initialized yet
    // if (!urlLang && !isInitialized.current) {
    //   isInitialized.current = true;
    //   // Preserve existing query parameters (UTMs, gclid, etc.)
    //   const params = new URLSearchParams(window.location.search);
    //   params.set("lang", targetLang);
    //   navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    // } else if (urlLang) {
    //   isInitialized.current = true;
    // }
  }, [location.pathname, location.search, navigate]);
};
